import knowledgeBase from '../data/mockKnowledgeBase.json';

// Simulated delay to feel like a real API
const SIMULATED_DELAY = 600;

export const sendMessageToBot = async (message) => {
    // Simulate network delay
    await new Promise(resolve => setTimeout(resolve, SIMULATED_DELAY));

    const lowerMsg = message.toLowerCase();

    // 1. Search Knowledge Base
    // Look for a match where the user's message contains a keyword
    const match = knowledgeBase.faq.find(entry =>
        entry.keywords.some(keyword => lowerMsg.includes(keyword))
    );

    let responseText;

    if (match) {
        responseText = match.answer;
    } else {
        // Fallback or "Small Talk" handling
        if (lowerMsg.includes('hello') || lowerMsg.includes('hi')) {
            responseText = "Hello! I'm the Peace Corps Assistant. I can tell you about the **Benefits** of serving, **Countries** we work in, or how to **Apply**. How can I help you regarding your future journey?";
        } else if (lowerMsg.includes('thank')) {
            responseText = "You're welcome! Let me know if you have any other questions about the Peace Corps.";
        } else {
            responseText = knowledgeBase.default;
        }
    }

    return {
        text: responseText,
        sender: 'bot',
        timestamp: new Date().toISOString()
    };
};
